/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Product reviews methods
 * -----------------------------------------------------------------------------
 *
 * @namespace restockMaster
 */

var restockMasterMethods = {
  data: function data() {
    return {
      // your data here
    };
  },


  methods: {
    _initRestockMasterMethods: function _initRestockMasterMethods() {
      if (!window.theme.restockMasterEnabled) {
        return;
      }

      app._getRestockData();
    },
    _getRestockData: function _getRestockData(id, variantsAll, tagsAll) {
      // Basic function to load script files, will be used to include jQuery
      var loadScript = function loadScript(url, callback) {
        var script = document.createElement("script");
        script.type = "text/javascript";
        // If the browser is Internet Explorer
        if (script.readyState) {
          script.onreadystatechange = function () {
            if (script.readyState == "loaded" || script.readyState == "complete") {
              script.onreadystatechange = null;
              callback();
            }
          };
          // For any other browser
        } else {
          script.onload = function () {
            callback();
          };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
      };

      // This is our JavaScript that we'll run after jQuery is included
      var rnPopupJS = function rnPopupJS($) {
        $(document).ready(function () {
          if (window.restock.page_type == 'product' || window.restock.page_type == 'collection') {
            var product_page_btn_condition = function product_page_btn_condition() {
              if (variants != undefined) {
                var options = [];

                if (window.restock.page_type == 'collection') {
                  $('[data-single-option-selector]').each(function () {
                    options.push($(this).val());
                  });
                } else {
                  $('.restock-form [data-single-option-selector]:checked').each(function () {
                    options.push($(this).val());
                  });
                }

                options = $.grep(options, function (n) {
                  return n;
                });
                if (options.length > 0) {
                  var selected_variant_title;
                  if (options.length == 1) {
                    selected_variant_title = options;
                  } else {
                    if (options[2] != undefined) {
                      selected_variant_title = options[0] + ' / ' + options[1] + ' / ' + options[2];
                    } else {
                      selected_variant_title = options[0] + ' / ' + options[1];
                    }
                  }
                  // var flag = 0;
                  $.each(variants, function (key, val) {
                    if ($.trim(val.title) == $.trim(selected_variant_title) && val.available == false) {
                      $('.email-when-available').show();
                      // $('[data-addcart-custom]').hide();
                      $('#selectVariant').val(val.id).change();
                      return false;
                    } else {
                      $('.email-when-available').hide();
                      $('[data-addcart-custom]').show();
                    }
                  });
                } else {
                  if (!variants[0].available) {
                    $('.email-when-available').show();
                    // $('[data-addcart-custom]').hide();
                    $('#selectVariant').val(variants[0].id).change();
                  } else {
                    $('.email-when-available').hide();
                    $('[data-addcart-custom]').show();
                  }
                }
              }
            };

            var validateEmail = function validateEmail(email) {
              var mha_emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
              return mha_emailReg.test(email);
            };

            if (window.restock.page_type == 'collection') {
              var variants = variantsAll;
            } else {
              var variants = window.restock.product.variants;
            }

            var isMobile = window.matchMedia('only screen and (max-width: 767px)');
            var mha_device = 'desktop';
            if (isMobile.matches) {
              mha_device = 'mobile';
            }
            var tagsRelated = void 0;
            if (window.restock.page_type == 'product') {
              tagsRelated = window.restock.product.tags;
            } else {
              tagsRelated = tagsAll;
            }
            $.ajax({
              type: 'GET',
              url: window.restock.partner_url + '/restock_notifier/frontend/get_product_page_btn',
              data: {
                store_id: window.restock.store_id,
                device: mha_device,
                tags: tagsRelated
              },
              crossDomain: true,
              success: function success(data) {
                window.hulkappsc = {};
                window.hulkappsc.$first_add_to_cart_el = null;
                var selectors = [".btn--add-to-cart", "button[name='add']", "#add-to-cart", "#AddToCartText", "#AddToCart"];
                var found_selectors = 0;
                selectors.forEach(function (selector) {
                  found_selectors += $(selector).length;
                  if (window.hulkappsc.$first_add_to_cart_el == null && found_selectors) {
                    window.hulkappsc.$first_add_to_cart_el = $(selector);
                  }
                });

                if (data['type'] == 'custom') {
                  if ($('body').find("#mhaRnProduct").length > 0) {
                    if (data['data']) {
                      $(".mhaRnProduct").html(data['data']);
                    }
                  } else {
                    if (data['data']) {
                      window.hulkappsc.$first_add_to_cart_el.after('<div id="mhaRnProduct">' + data['data'] + '</div>');
                    }
                  }
                } else {
                  if (data['data']) {
                    $('body').append('<div id="mhaRnProduct">' + data['data'] + '</div>');
                    setTimeout(function () {
                      $('#mhaRnProduct').show();
                    }, 500);
                  }
                }
                var idProduct = void 0;
                if (window.restock.page_type == 'product') {
                  idProduct = window.restock.product.id;
                } else {
                  idProduct = id;
                }
                $.ajax({
                  type: 'GET',
                  url: window.restock.partner_url + '/restock_notifier/frontend/get_sign_up_form',
                  data: {
                    store_id: window.restock.store_id,
                    product_id: idProduct
                  },
                  crossDomain: true,
                  success: function success(data) {
                    $('#mhaRnProduct').after(data);
                    if (window.restock.customer) {
                      $('.rn-email #usr').val(window.restock.customer.email);
                    }
                    product_page_btn_condition();
                    $(document).on('change', 'form [data-single-option-selector]', function () {
                      product_page_btn_condition();
                    });
                  }
                });
              }
            });
          }
        });
      };

      // Check if jQuery is added, if not, then we'll loadScript, otherwise, run reChargeJS
      if (typeof window.restock !== 'undefined') {
        if (typeof jQuery == 'undefined' || parseInt(jQuery.fn.jquery) == 3 && parseFloat(jQuery.fn.jquery.replace(/^1\./, "")) < 2.1) {
          // We'll get our jQuery from Google APIs
          loadScript('//ajax.googleapis.com/ajax/libs/jquery/3.2.1/jquery.min.js', function () {
            jQuery321 = jQuery.noConflict(true);
            rnPopupJS(jQuery321);
          });
        } else {
          rnPopupJS(jQuery);
        }
      }
    }
  }
};

export default restockMasterMethods;